export default "__VITE_ASSET__D0YnxRgf__"